export default __webpack_public_path__ + "static/media/Washingtonplatz_Coreo.4418efc7.jpg";